import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ResigteringService } from '../auth/resigtering.service';

@Component({
  selector: 'app-verification-code',
  templateUrl: './verification-code.component.html',
  styleUrl: './verification-code.component.scss',
})
export class VerificationCodeComponent implements OnInit {
  contentReady: boolean = false;
  str1!: string;
  str2!: string;
  str3!: string;
  str4!: string;
  errorExist!: boolean;
  str: string = '';

  formVerification = new FormGroup({
    verificationCode1: new FormControl(''),
    verificationCode2: new FormControl(''),
    verificationCode3: new FormControl(''),
    verificationCode4: new FormControl('')
  });

  constructor(
    private formBuilder: FormBuilder,
    private _registerService: ResigteringService,
    private _Router: Router
  ) {}

  ngOnInit(): void {
    this.gotoTop()
    this.formVerification = this.formBuilder.group({
      verificationCode1: ['', [Validators.required, Validators.maxLength(1)]],
      verificationCode2: ['', [Validators.required, Validators.maxLength(1)]],
      verificationCode3: ['', [Validators.required, Validators.maxLength(1)]],
      verificationCode4: ['', [Validators.required, Validators.maxLength(1)]]
    });
  }

  verificationSubmit() {
    this.contentReady = true;
    if (!this.formVerification.valid) {
      this.contentReady = false;
      console.log(this.str1);
      return;
    }
    this.str = `${this.str1}${this.str2}${this.str3}${this.str4}`;
    console.log(this.str1);

    this._registerService.verificationCode(this.str).subscribe({
      next: (res) => {

        this.contentReady = false;
        sessionStorage.setItem('token', res.token);
        this._registerService.setToken(res.token);


        this._Router.navigate(['/Home']).then(() => {
          window.location.reload();
        });
      },
      error: (err) => {
        this.contentReady = false;
        this.errorExist = true;
        console.log(err);
      },
    });
  }

  skip() {
    this.contentReady = true;

    this._registerService.SkipVerificationCode().subscribe({
      next: (res) => {

        this.contentReady = false;
        localStorage.setItem('token', res.token);
        this._registerService.setToken(res.token);

        this._Router.navigate(['/Home']).then(() => {
          window.location.reload();
        });

      },
      error: (err) => {
        this.contentReady = false;
        this.errorExist = true;
        console.log(err);
      },
    });
  }
  gotoTop() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }
  moveFocus(currentInput: HTMLInputElement, nextInput: HTMLInputElement){
    if(currentInput.value.length === 1){
      nextInput.focus();
    }
  }
}
